import { CommentsWidgetState } from './comments-widget-state';

class CommentsWidgetApi {
    constructor(state = new CommentsWidgetState()) {
        this._state = state;
        this._LF = null;
    }
    init() {
		this.updateCount();
    }
    get LF(){
    	if(this._LF==null){
    		this.LF = window.LF || null;
    	}
    	return this._LF;
    }
    set LF(LF){
    	this._LF = LF;
    }
    get state() {
        return this._state;
    }
    set state(state) {
        this._state = state;
    }
    setCount(count) {
        this.state.count = count;
    }
    updateCount() {
        let api = this; // Can't access api's this' context in the replacer function
        
        /* window.LF.CommentCount({
            replacer: function(element, count) {
                api.state.element = element;
                api.state.count = count;
            }
        }); */
		
    }
}

export { CommentsWidgetApi }